import AnchorNavigationUtil from '@frontend/utils/AnchorNavigationUtil';

export default class StageProduct {
	private readonly element: HTMLElement;

	private static domSelectors = {
		link: '.m-stage-product__image-link[href^="#"]'
	};

	public constructor(element: HTMLElement) {
		this.element = element;
		this.init();
	}

	private init(): void {
		const links = this.element.querySelectorAll(StageProduct.domSelectors.link);

		links.forEach((link): void => {
			link.addEventListener('click', this.handleClick);
		});
	}

	protected handleClick = (event: Event): void => {
		event.preventDefault();

		const link = event.currentTarget as HTMLLinkElement;
		const target = link.getAttribute('href') as string;

		if (target) {
			AnchorNavigationUtil.goToAnchor(target);
		}
	};
}
